import {
    ADD_API_CONFIGURATION,
    ALL_API_CONFIGURATION,
    EDIT_API_CONFIGURATION
 } from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  data: null,
}

const ApiConfiguration= (state = initialState, action) => {
  switch (action.type) {
    case ADD_API_CONFIGURATION:
      state = {
        ...state,
        loading: true,
      }
      break
    case ALL_API_CONFIGURATION:
      state = {
        ...state,
        loading: false,
        data: action.payload.data,
      }
      break
    case EDIT_API_CONFIGURATION:
      state = {
        ...state,
        loading: false,
      }
      break
    default:
      break
  }
  return state
}

export default ApiConfiguration